module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-view",
    domProps: {
      "innerHTML": _vm._s(_vm.currentValue)
    }
  }, [_vm._v("\n  " + _vm._s(_vm.currentValue) + "\n")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a8b25320"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/feed/feed-content.vue
// module id = 290
// module chunks = 107